import { Link } from "react-router-dom";
import { Award, ArrowUpRight } from "lucide-react";

export default function CourseCard({ f, progress = null, linkTo = null }) {
  return (
    <Link
      to={linkTo || `/formations/${f.slug}`}
      data-testid={`course-card-${f.slug}`}
      className="group block card-soft overflow-hidden transition-transform hover:-translate-y-1 hover:shadow-lg"
      style={{ transitionProperty: "transform, box-shadow" }}
    >
      <div className="aspect-[16/10] overflow-hidden bg-slate-100 relative">
        <img src={f.thumbnail} alt={f.title} className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105" />
      </div>
      <div className="p-6">
        <div className="flex flex-wrap gap-1.5 mb-3">
          {f.tags?.map((t) => (
            <span key={t} className="text-[11px] font-medium uppercase tracking-wider text-brand-800 bg-brand-50 rounded-full px-2 py-0.5">{t}</span>
          ))}
        </div>
        <h3 className="font-display font-bold text-lg text-slate-900 leading-snug">{f.title}</h3>
        <p className="text-sm text-slate-600 mt-1.5 line-clamp-2">{f.subtitle}</p>

        {progress !== null && (
          <div className="mt-4">
            <div className="flex justify-between text-xs text-slate-500 mb-1.5">
              <span>Progression</span>
              <span className="font-semibold text-slate-700">{progress}%</span>
            </div>
            <div className="h-1.5 bg-slate-100 rounded-full overflow-hidden progress-anim">
              <div className="h-full bg-brand-500" style={{ "--target": `${progress}%`, width: `${progress}%` }} />
            </div>
          </div>
        )}

        {progress === null && (
          <div className="flex items-center justify-between mt-5 pt-5 border-t border-slate-100">
            <div className="flex items-center gap-4 text-sm text-slate-600">
              <span className="flex items-center gap-1.5"><Award size={14} strokeWidth={1.5} />{f.level}</span>
            </div>
            <span className="flex items-center gap-1 text-sm font-semibold text-brand-700">
              Découvrir <ArrowUpRight size={14} strokeWidth={2} className="transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
            </span>
          </div>
        )}
      </div>
    </Link>
  );
}
